<template>
  <div
    v-if="!element.checklistGroupActionIsArchived"
    :key="element.id"
    class="tw-flex tw-w-full tw-flex-col step tw-bg-[#fcfcfd] tw-rounded-[6px] tw-mb-[25px]"
    :style="
      element.id === idItemExpand ? 'box-shadow: 0 0 4px 0 #0000000d' : ''
    "
  >
    <div
      :style="`${
        v$.checklistGroupActionName.$error || v$.checklistGroupActionHtml.$error
          ? 'border: 1px solid #dc3545; background-color: #fee5e2'
          : ''
      }`"
      class="tw-flex tw-flex-row tw-items-center tw-justify-between tw-px-[25px] tw-py-[20px] step__content"
    >
      <div
        class="tw-flex tw-w-full tw-flex-row tw-items-center"
        :style="`line-height: ${inModalEdit || inModalAdd ? '22px' : '28px'} `"
      >
        <span
          v-if="
            !isEditAction ||
            inModalAdd ||
            (inModalEdit && (checkListGroupId || action))
          "
          class="tw-w-2 tw-h-full"
          :style="`cursor: ${!isEditAction ? 'not-allowed' : 'pointer'}`"
        >
          <DraggableIcon class="drag-handle" :width="8" :height="12" />
        </span>
        <span
          :class="`order tw-text-[#211f58] tw-text-center tw-font-semibold tw-leading-[100%] content tw-ml-[10px] ${
            inModalAdd || inModalEdit ? 'tw-text-[14px]' : 'tw-text-[16px]'
          }`"
        >
          {{
            getComponentUiText(
              "app-assess-recommendations-action-table-action-plan-task-1",
            )
          }}
          {{
            `${index + 1}${
              element.optional
                ? ` - ${getComponentUiText(
                    "app-assess-recommendations-action-table-steps-solve-step-optional-1",
                  )}`
                : ""
            }`
          }}:
        </span>
        <span
          class="step-title tw-text-[#211f58] tw-text-center tw-text-[16px] tw-font-normal tw-ml-[10px]"
        >
          {{ element.checklistGroupActionName }}
        </span>
      </div>
      <ButtonShowMore
        v-if="inModalAdd || (inModalEdit && (checkListGroupId || action))"
        :id-popover="'popover-btn-show-more-list-step-' + index"
        :is-from-notification="true"
      >
        <CustomDropDownItem
          :style="'danger'"
          :id-text="'app-settings-domain-verify-modal-delete-button-1'"
          @click="removeStep(index)"
        />
      </ButtonShowMore>
      <ArrowDownTableIcon
        :class="[
          'arrow tw-ml-[5px]',
          element.id === idItemExpand ? 'arrow-up' : 'arrow-down',
          'tw-cursor-pointer',
        ]"
        @click="
          () => {
            if (idItemExpand === element.id) {
              //   title = '';
              //   description = '';
              //   optional = false;
              //   idItemExpand = null;
              handleUpdateExpand(null);
            } else {
              //   title = element.title;
              //   description = element.description;
              //   optional = element.optional;
              //   idItemExpand = element.id;
              handleUpdateExpand(element.id);
            }
          }
        "
      />
    </div>
    <div v-show="element.id === idItemExpand">
      <div
        v-if="inModalAdd || inModalEdit"
        class="detail tw-flex tw-p-[25px] tw-gap-[20px] tw-bg-white tw-flex-col"
      >
        <BaseInput
          v-model="element.checklistGroupActionName"
          :read-only="inModalEdit && !checkListGroupId && !action"
          :class-name="`modal-edit-action-step-input`"
          input-class="!tw-h-[56px]"
          :id-focus="'input-focus'"
          :validation="v$.checklistGroupActionName"
          :validate-on-blur="true"
          :valid-message="
            getComponentUiText(
              'app-assess-recommendations-edit-action-modal-action-detail-required-1',
            )
          "
          :placeholder="
            getComponentUiText(
              'app-assess-recommendations-edit-action-modal-action-detail-placeholder-1',
            )
          "
          :label="
            getComponentUiText(
              'app-assess-recommendations-edit-action-modal-action-detail-title-1',
            )
          "
          @update:model-value="
            (text) => {
              element.checklistGroupActionName = text;
              handleUpdateData();
            }
          "
        />
        <BaseInput
          v-if="inModalAdd || (inModalEdit && (checkListGroupId || action))"
          v-model="element.checklistGroupActionHtml"
          :validation="v$.checklistGroupActionHtml"
          class-name="modal-edit-action-step-input !tw-items-start"
          :placeholder="
            getComponentUiText(
              'app-assess-recommendations-edit-action-modal-action-detail-placeholder-1',
            )
          "
          :label="
            getComponentUiText(
              'app-assess-recommendations-edit-action-modal-action-detail-description-1',
            )
          "
          @update:model-value="null"
        >
          <WYSiwygEditor
            v-model="element.checklistGroupActionHtml"
            :validate="v$.checklistGroupActionHtml.$error"
            :include-image="false"
            @update:blur="handleBlurDescription"
            @update:value="
              (text) => {
                element.checklistGroupActionHtml = text;
                handleUpdateData();
              }
            "
          />
        </BaseInput>
        <div v-else class="row">
          <div class="col-sm-5 tw-font-medium tw-text-[14px]">
            {{
              getComponentUiText(
                "app-assess-recommendations-edit-action-modal-action-detail-description-1",
              )
            }}
            <span class="tw-ml-1 tw-text-[#F7553C]">*</span>
          </div>

          <div class="col-sm-7">
            <customDescriptionContent
              :description="element.checklistGroupActionHtml"
            />
          </div>
        </div>
      </div>
      <div
        v-else
        class="detail tw-flex tw-p-[35px] tw-gap-[30px] tw-bg-white tw-flex-col"
      >
        <div
          class="tw-flex tw-flex-col tw-gap-[35px] tw-items-start md:tw-flex-row md:tw-items-center"
        >
          {{
            element.checklistGroupActionImages[0]?.checklistGroupActionImageFile
          }}
          <img
            :src="
              parseDescription(
                element.checklistGroupActionImages[0]
                  ?.checklistGroupActionImageFile,
              )
            "
            alt=""
            class="tw-max-w-[225px] lg:tw-max-w-[320px]"
          />
          <div class="tw-gap-[12px] tw-flex tw-flex-col">
            <div
              class="title-detail-step tw-text-[#211f58] tw-text-[18px] tw-font-medium tw-leading-[145%]"
            >
              <customDescriptionContent
                :description="element.checklistGroupActionHtml"
              />
            </div>
          </div>
        </div>
        <!--
 <BButton
          variant="primary"
          class="tw-bg-[#387DFF] tw-border-0 tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px] tw-leading-[100%] tw-w-[fit-content]"
          type="submit"
        >
          {{
            getComponentUiText(
              "app-assess-recommendations-action-table-steps-solve-button-title-1",
            )
          }}
        </BButton> 
-->
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { getComponentUiText } from "@/utils/utilities";
import { reactive, watch } from "vue";
import DraggableIcon from "@/components/svgs/draggableIcon.vue";
import ArrowDownTableIcon from "@/components/svgs/arrowDownTableIcon.vue";
import BaseInput from "@/components/common/form/baseInput.vue";
import WYSiwygEditor from "@/components/common/wysiwygEditor.vue";
import customDescriptionContent from "@/components/common/customDescriptionContent.vue";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import { useVuelidate } from "@vuelidate/core";
import { any } from "joi";
import { helpers, required } from "@vuelidate/validators";
import store from "@/store";
const props = defineProps({
  inModalAdd: {
    type: Boolean,
    required: false,
    default: false,
  },
  inModalEdit: {
    type: Boolean,
    required: false,
  },
  item: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  idItemExpand: {
    type: any,
    required: true,
  },
  checkListGroupId: {
    type: Boolean,
    required: false,
    default: false,
  },
  action: {
    type: Boolean,
    required: false,
    default: false,
  },
  isEditAction: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const element = reactive({ ...props.item });
// const idItemExpand = props.idItemExpand;
const parseDescription = (data) => {
  try {
    const description = data;
    const startChar = description.slice(0, 2);
    return `data:image/${
      startChar !== "iV" ? "svg+xml" : "png"
    };base64,${description}`;
  } catch (e) {
    // description.value = data;
  }
};

watch(
  () => store.state.Recommend.isCreatingAction,
  () => {
    if (store.state.Recommend.isCreatingAction === true) {
      saveChanges();
    }
  },
);

const emits = defineEmits(["changeExpand", "RemoveStep", "handleUpdateData"]);
const handleUpdateExpand = (id) => {
  emits("changeExpand", id);
};
const removeStep = (index) => {
  emits("RemoveStep", index);
};
const handleUpdateData = () => {
  element.isEdit = true;
  emits("handleUpdateData", element, props.index);
};
const handleBlurDescription = async () => {
  v$.value.checklistGroupActionHtml.$touch();
};
const rules = {
  checklistGroupActionName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
  checklistGroupActionHtml: {
    required: helpers.withMessage(
      () => getComponentUiText("app-setting-org-detail-required-fields-1"),
      required,
    ),
  },
};
const v$ = useVuelidate(rules, element as any);
const saveChanges = async () => {
  await v$.value.$validate();
  store.commit("Recommend/SET_LIST_STEP_VALIDATION_STATE", {
    id: element.id,
    isValid: !v$.value.$error,
  });
};
</script>
